import {useActions, useGetters, useMutators, useState} from './_default.js';
export default {
    namespaced: true,
    state: {
        ...useState(),
        listUrl: '/payload/paginated/sidebar/task',
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
